import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import google from "../../Assets/Images/bi_google.svg";
import apple from "../../Assets/Images/bi_apple.svg";
import { auth, provider_apple } from "../../Config/firebase-config";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";

import "../../Assets/Styles/pages/signIn.scss";
import { useTranslation } from "react-i18next";
import { LoginAPI, Logout } from "../../actions/Auth/Auth";
import { useDispatch } from "react-redux";
import { setUserAuth } from "../../Redux/UserSlice/userSlice";
import { GetAllTemplates } from "../../actions/Template/Template";
import { setAuthToken } from "../../Redux/AuthSlice/authSlice";
import { GetSettings } from "../../actions/Settings/Setting";
import SignInCard from "./signInCards";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

interface SignInProps {
  open: boolean;
  setOpen: (v: boolean) => void;
  setActive?: (v: string) => void;
}

const SignIn = ({ open, setOpen, setActive }: SignInProps) => {
  const [loader, setLoader] = useState("");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const provider_google = new GoogleAuthProvider();
  provider_google.setCustomParameters({
    prompt: "select_account",
  });

  const handlePage = (page: string) => {
    Promise.all([history.push(page), setOpen(false)]);
  };

  const handleClick_google = async () => {
    setLoader("google");
    try {
      const data = await signInWithPopup(auth, provider_google);
      const user = data.user;
      const customs = (user as { reloadUserInfo?: { customAttributes?: string } }).reloadUserInfo || {};
      const customAttributes = customs.customAttributes
        ? JSON.parse(customs.customAttributes)
        : {};
      const payload = {
        photoURL: user.photoURL,
        displayName: user.displayName,
        email: user.email,
      };
      dispatch(setAuthToken(await user.getIdToken()));
      // let dummyToken = "eyJhbGciOiJSUzI1NiIsImtpZCI6ImIyZGZmNzhhMGJkZDVhMDIyMTIwNjM0OTlkNzdlZjRkZWVkMWY2NWIiLCJ0eXAiOiJKV1QifQ.eyJuYW1lIjoiU3llZCBBbW1hciBLYXptaSIsInBpY3R1cmUiOiJodHRwczovL2xoMy5nb29nbGV1c2VyY29udGVudC5jb20vYS9BQWNIVHRlRUJwcGkxV0l0bFQ3QjltUWlCUHlJcGVoSXBOcXJWM1psM2xaUWs0SlpKVWc9czk2LWMiLCJyb2xlTmFtZSI6InVzZXIiLCJzdWJzY3JpcHRpb24iOiJmcmVlIiwiaXNzIjoiaHR0cHM6Ly9zZWN1cmV0b2tlbi5nb29nbGUuY29tL2V6eXdhdGVybWFyay00MTU2ZSIsImF1ZCI6ImV6eXdhdGVybWFyay00MTU2ZSIsImF1dGhfdGltZSI6MTY4OTkxNDQ0OCwidXNlcl9pZCI6IkF1M2JtM3V5OWtTZHJYNTM2NmtqUWljVnBtNjMiLCJzdWIiOiJBdTNibTN1eTlrU2RyWDUzNjZralFpY1ZwbTYzIiwiaWF0IjoxNjg5OTE0NDUxLCJleHAiOjE2ODk5MTgwNTEsImVtYWlsIjoia2F6bWk4MjAzM0BnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiZmlyZWJhc2UiOnsiaWRlbnRpdGllcyI6eyJnb29nbGUuY29tIjpbIjExMjUzMDI2NTQxNTA5OTc5NjgxMyJdLCJlbWFpbCI6WyJrYXptaTgyMDMzQGdtYWlsLmNvbSJdfSwic2lnbl9pbl9wcm92aWRlciI6Imdvb2dsZS5jb20ifX0.ZY5MekwO7HoeFasotVga9t1C4bJaw-07Qvx4uSIVBZBQ2FV-FRNmY8OHVMlAdKq4m6Ys4GjWO7N0QGCWjbohM_PVjjA1mKicuCm5kp1juzsyyk81lo2F_OEP8E7hMdu50HhSDyqCyi7TFcxYEU7SHO1800_3-G3x26niDXOPicPPV3a2HlODVaFjGEotnkql4s_0xqr201tuzjc2NtJNACC9UnkEMn39p8td5GSXvlebYJeg8RKCZiZfpJr34CDGWFop1J8M07yt9W13Fxu7mDygrqEfzXoNdT4TRJ3RAVWoAtcnIiUtSS7YJRcu0zMPUgbiAHi_5_0HWw4s4cl1pA"
      // dispatch(setAuthToken(dummyToken));
      if (!customAttributes?.subscription) {
        const resp = (await dispatch(LoginAPI())) as { email?: string } | false;
        if (resp && resp.email) {
          Promise.all([
            dispatch(GetAllTemplates()),
            dispatch(GetSettings()),
            dispatch(setUserAuth(payload)),
          ]);
          if (setActive) setActive("template");
          setOpen(false);
        } else {
          Promise.all([dispatch(Logout())]);
          alert(t("SignInError"));
        }
      } else {
        Promise.all([
          dispatch(GetAllTemplates()),
          dispatch(GetSettings()),
          dispatch(setUserAuth(payload)),
        ]);
        if (setActive) setActive("template");
        setOpen(false);
      }
    } catch (error) {
      dispatch(Logout());
      alert(t("SignInError"));
    } finally {
      setLoader("");
    }
  };
  const handleClick_apple = async () => {
    if (loader === "apple") setLoader("");
    else setLoader("apple");

    try {
      provider_apple.addScope("email");
      provider_apple.addScope("name");
      const data = await signInWithPopup(auth, provider_apple);
      const customs = (data.user as { reloadUserInfo?: { customAttributes?: string } }).reloadUserInfo;
      const payload = {
        photoURL: data.user.photoURL,
        displayName: data.user.displayName,
      };
      dispatch(setUserAuth(payload));
      dispatch(setAuthToken(await data.user.getIdToken()));

      const customAttributes =
        customs && Object.prototype.hasOwnProperty.call(customs, "customAttributes")
          ? JSON.parse(customs.customAttributes)
          : {};

      if (
        !(
          customAttributes &&
          customAttributes.hasOwnProperty("roleName") &&
          customAttributes.hasOwnProperty("env") &&
          process.env.REACT_APP_ENVIRONMENT === customAttributes.env
        )
      ) {
        //"{"roleName":"user"}"
        const resp = (await dispatch(LoginAPI())) as { email?: string } | false;
        if (resp && "email" in resp && resp.email) {
          setOpen(false);
        }
      } else setOpen(false);
      if (setActive) setActive("template");
    } catch (e) {
      setLoader("");

      console.log("Firebase error: ", e);
    }
    setLoader("");
    Promise.all([dispatch(GetAllTemplates()), dispatch(GetSettings())]);
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 800,
      }}
    >
      <Fade in={open}>
        <Row className="model_signIn m-0">
          <Col className="m-0 p-0 px-4  productSansLight text_16 signIn_img d-none d-lg-flex flex-column justify-content-start align-items-center">
            <span className="signIn_img_text productSansLight text_36 text-start w-100">
              {t("lang.ezywatermark")}
            </span>
            <span className="text-white w-100 my-3">
              {t("SignIn.Subtext1")}
            </span>
            <span className="text-white w-100 mb-3">
              {t("SignIn.Subtext2")}
            </span>
            <span className="text-white w-100 mb-3">
              {t("SignIn.Subtext3")}
            </span>
          </Col>
          <Col className="margin_sign my-Large-5 p-0 px-4 ps-5 productSansLight text_18 d-flex flex-column justify-content-center align-items-start">
            <span className="signIn_text productSansBold text_22 w-100">
              {t("SignIn.SignIn")}
            </span>
            <span className="signIn_text text_16 productSansLight w-100 mb-4">
              {t("SignIn.SubtextSignin")}
            </span>
            <div className="signIndiv">
              <SignInCard
                loader={loader}
                component={"google"}
                src={google}
                handleClick={handleClick_google}
                text={"SignIn.SignGoogle"}
              />
              <SignInCard
                loader={loader}
                component={"apple"}
                src={apple}
                handleClick={handleClick_apple}
                text={"SignIn.SignApple"}
              />
            </div>
            <span className="text_15 signIn_agreement_text w-100 mt-4 ">
              {t("SignIn.Agreement")}
            </span>
            <span
              onClick={() => {
                handlePage("/terms");
              }}
              className="text_15 pointer Aktiv_Medium text-start signIn_terms_text"
            >
              {t("SignIn.Terms")}
            </span>
          </Col>
        </Row>
      </Fade>
    </Modal>
  );
};

export default SignIn;
